export default __webpack_public_path__ + "757b6fe04b4195b94944bb27169ac16f.jpg";